let RegExpHelper = function () {

    /*
    Modifier	
    i	Perform case-insensitive matching
    g	Perform a global match (find all matches rather than stopping after the first match)
    m	Perform multiline matching
    
    Expression	
    [abc]	Find any character between the brackets
    [^abc]	Find any character NOT between the brackets
    [0-9]	Find any character between the brackets (any digit)
    [^0-9]	Find any character NOT between the brackets (any non-digit)
    (x|y)	Find any of the alternatives specified
    
    Metacharacter	
    .	Find a single character, except newline or line terminator
    \w	Find a word character
    \W	Find a non-word character
    \d	Find a digit
    \D	Find a non-digit character
    \s	Find a whitespace character
    \S	Find a non-whitespace character
    \b	Find a match at the beginning/end of a word
    \B	Find a match not at the beginning/end of a word
    \0	Find a NUL character
    \n	Find a new line character
    \f	Find a form feed character
    \r	Find a carriage return character
    \t	Find a tab character
    \v	Find a vertical tab character
    \xxx	Find the character specified by an octal number xxx
    \xdd	Find the character specified by a hexadecimal number dd
    \uxxxx	Find the Unicode character specified by a hexadecimal number xxxx
    
    Quantifier	
    n+	Matches any string that contains at least one n
    n*	Matches any string that contains zero or more occurrences of n
    n?	Matches any string that contains zero or one occurrences of n
    n{X}	Matches any string that contains a sequence of X n's
    n{X,Y}	Matches any string that contains a sequence of X to Y n's
    n{X,}	Matches any string that contains a sequence of at least X n's
    n$	Matches any string with n at the end of it
    ^n	Matches any string with n at the beginning of it
    ?=n	Matches any string that is followed by a specific string n
    ?!n	Matches any string that is not followed by a specific string n
    */

    /**
     * Valida solo caracteres Numericos
     * @param {any} textoValidar
     */
    function _soloNumericos(textoValidar) {
        let regularExpression = new RegExp("^[0-9]+$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
     * Valida solo caracteres Alfabeticos
     * @param {any} textoValidar
     */
    function _soloAlfabeticos(textoValidar) {
        let regularExpression = new RegExp("^[a-zA-z]+$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
     * Valida solo caracteres Alfanumericos
     * @param {any} textoValidar
     */
    function _soloAlfanumericos(textoValidar) {
        let regularExpression = new RegExp("^[a-zA-z0-9]+$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
    * Valida solo caracteres Alfanumericos con espacios
    * @param {any} textoValidar
    */
    function _soloAlfanumericosConEspacios(textoValidar) {
        let regularExpression = new RegExp("^[a-zA-z0-9_ ]+$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
    * Valida Numero de Documentos
    * @param {any} textoValidar
    */
    function _soloNumeroDocumentos(textoValidar) {
        let regularExpression = new RegExp("^[0-9]{6,11}$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
    * Valida Email
    * @param {any} textoValidar
    */
    function _soloEmail(textoValidar) {
        let regularExpression = new RegExp("^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$");
        let resultado = verificarRegularExpression(textoValidar, regularExpression);
        return resultado;
    }

    /**
    * Verifica el texto ingresado y la expresion regular
    * @param {any} textoValidar
    */
    function verificarRegularExpression(textoValidar, regularExpression) {
        let resultado = false;
        if (regularExpression.test(textoValidar)) {
            if (textoValidar != "") {
                resultado = true;
            }
        }
        return resultado;
    }

    return {
        SoloNumericos: function (textoValidar) {
            return _soloNumericos(textoValidar);
        },

        SoloAlfabeticos: function (textoValidar) {
            return _soloAlfabeticos(textoValidar);
        },

        SoloAlfanumericos: function (textoValidar) {
            return _soloAlfanumericos(textoValidar);
        },

        SoloAlfanumericosConEspacios: function (textoValidar) {
            return _soloAlfanumericosConEspacios(textoValidar);
        },

        SoloNumeroDocumentos: function (textoValidar) {
            return _soloNumeroDocumentos(textoValidar);
        },

        SoloEmail: function (textoValidar) {
            return _soloEmail(textoValidar);
        },

        //Patron de 1 a 98
        Pattern1to98: function () {
            return /^([1-9]?\d|10)$/;
        },

        //Patron de 2 a 9
        Pattern2to9: function () {
            return /^([2-9]?\d|1)$/;
        },

        //Patron de 0 a 100
        Pattern0to100: function () {
            return /^([0-9]?\d|100)$/;
        },

        //Patron de 0 a 1000000000
        Pattern0to1000000000: function () {
            return /^([0-9]?\d|1000000000)$/;
        }
    }
}

let regExpHelper = new RegExpHelper();
export default regExpHelper;